import { FC } from 'react';
import { ACCORDION_LIST } from '../../../../helpers/testIds';
import * as List from './AccordionList.styles';
import { IAccordionList } from './AccordionList.types';

export const AccordionList: FC<IAccordionList> = ({ items, ...otherProps }: IAccordionList) => {
  const testId = otherProps['data-testid'] || ACCORDION_LIST;
  const itemList = items || [];
  return (
    <List.Wrapper {...otherProps} data-testid={testId}>
      {itemList.map((item, index) => {
        const itemID = item.props.id || index;
        return (
          <List.Item key={itemID} data-testid={`${testId}_${index}`}>
            {item}
          </List.Item>
        );
      })}
    </List.Wrapper>
  );
};

AccordionList.displayName = 'AccordionList';
